import {scroller} from 'react-scroll'

export const scrollTo = (to) => {
    scroller.scrollTo(to, {
        duration: 1500,
        delay: 1000,
        smooth: 'easeInOutQuart'
    })
}

export const fastScrollTo =(to) => {
    scroller.scrollTo(to, {
        duration: 0,
        delay: 0,
        smooth: 'easeInOutQuart'
    })
}

export const customScroll =(to, delay)=>{
    scroller.scrollTo(to, {
        duration: 1000,
        delay: delay,
        smooth: 'easeInOutQuart'
    })
}